/**
 * Price calculator — mirrors BookingDetails.js:442 formula EXACTLY.
 *
 * DO NOT modify. If backend/frontend booking formula changes, update this
 * mirror in parallel. This module is a read-only reflection to power
 * marketing/SEO widgets — no business logic.
 */

// Backend vehicle_categories.base_price (mirror of DB seed).
// Source of truth: /app/backend/routes/vehicle_categories.py DEFAULT_CATEGORIES
export const VEHICLE_BASE = {
  economy:  18,
  comfort:  38,
  business: 48,
  premium:  50,
  vip:      99,
  suv:      39,
  van:      37,
  minibus:  100,
  bus:      207,
};

export const VEHICLE_META = [
  // Display-normalized: lug >= pax (1 Gepäckstück pro Person minimum).
  { id: 'economy',  labelDe: 'Economy',  labelEn: 'Economy',  pax: 4,  lug: 4 },
  { id: 'comfort',  labelDe: 'Komfort',  labelEn: 'Comfort',  pax: 4,  lug: 4 },
  { id: 'business', labelDe: 'Business', labelEn: 'Business', pax: 3,  lug: 3 },
  { id: 'premium',  labelDe: 'Premium',  labelEn: 'Premium',  pax: 3,  lug: 3 },
  { id: 'vip',      labelDe: 'VIP',      labelEn: 'VIP',      pax: 3,  lug: 4 },
  { id: 'suv',      labelDe: 'SUV',      labelEn: 'SUV',      pax: 6,  lug: 6 },
  { id: 'van',      labelDe: 'Van',      labelEn: 'Van',      pax: 8,  lug: 8 },
  { id: 'minibus',  labelDe: 'Kleinbus', labelEn: 'Minibus',  pax: 16, lug: 16 },
];

/**
 * Single-vehicle estimate — mirrors BookingDetails.js:442.
 * @param {string} vehicleId  economy|comfort|…
 * @param {number} distanceKm distance in kilometres
 * @returns {number} rounded euro price (integer)
 */
export function estimatePrice(vehicleId, distanceKm) {
  const base = VEHICLE_BASE[vehicleId];
  if (base == null || !distanceKm) return base || 0;
  return Math.round(base + (base * distanceKm / 100 * 0.5));
}

/**
 * Range across all vehicle types the widget offers.
 * Returns { low, high, byVehicle } where byVehicle is a plain map.
 */
export function estimateRange(distanceKm) {
  const byVehicle = {};
  let low = Infinity, high = 0;
  for (const meta of VEHICLE_META) {
    const p = estimatePrice(meta.id, distanceKm);
    byVehicle[meta.id] = p;
    if (p < low) low = p;
    if (p > high) high = p;
  }
  return { low: low === Infinity ? 0 : low, high, byVehicle };
}
